<template>
  <div class="app-container" v-loading="listLoading">
    <el-form
      ref="form"
      :model="form"
      style="width: 80%"
      label-width="220px"
      :rules="rules"
    >
      <!-- <el-form-item label="封面(176*116)" prop="cover">
        <upload-one v-model="form.cover" width="200px"></upload-one>
      </el-form-item> -->
      <el-form-item label="标题:" prop="title">
        <el-input
          v-model="form.title"
          style="width: 250px"
          placeholder="请输入标题"
          maxlength="255"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="内容:" prop="content">
        <el-input
          v-model="form.content"
          style="width: 450px"
          placeholder="请输入内容"
          clearable
          type="textarea"
          :rows="4"
          maxlength="100"
        ></el-input>
      </el-form-item>

      <!-- <el-form-item label="来源:" prop="from">
        <el-input
          v-model="form.from"
          style="width: 250px"
          placeholder="请输入源"
          clearable
        ></el-input>
      </el-form-item> -->

      <!-- <el-form-item label="内容:" prop="content">
        <el-input
          v-model="form.content"
          style="width: 450px"
          placeholder="请输入描述"
          clearable
          type="textarea"
          :rows="4"
          maxlength="255"
        ></el-input>
      </el-form-item>
      <el-form-item label="资讯详情:" prop="details">
        <Tinymce
          :height="400"
          v-model="form.details"
          :value="form.details"
          ref="content"
        />
      </el-form-item> -->

      <el-form-item>
        <el-button @click="$router.go(-1)">返回</el-button>
        <el-button type="primary" @click="handler" :loading="btnLoading">
          提交
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import request from "@/utils/request";
import Tinymce from "@/components/Tinymce";
import UploadOne from "@/components/UploadOne/index.vue";
import UploadList from "@/components/UploadList/index.vue";
export default {
  components: {
    Tinymce,
    UploadOne,
    UploadList,
  },
  data() {
    return {
      listLoading: false,
      btnLoading: false,
      regions: [],
      serviceType: [],
      provinces: [],
      cities: [],
      areas: [],
      institutes: [],
      form: {
        id: "",
        cover: "",
        title: "",
        details: "",
        content: "",
      },
      region: null,
      dynamicTags: [],
      inputVisible: false,
      inputValue: "",
      industrie_id: "",
      industries: [],
      industrie_detaileds: [],
      rules: {
        cover: [{ required: true, message: "封面不能为空", trigger: "blur" }],
        image: [{ required: true, message: "图片不能为空", trigger: "blur" }],
        title: [{ required: true, message: "标题不能为空", trigger: "blur" }],
        details: [{ required: true, message: "详情不能为空", trigger: "blur" }],
        content: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        venue: [
          { required: true, message: "举办地点不能为空", trigger: "blur" },
        ],
        province_code: [
          { required: true, message: "省份不能为空", trigger: "change" },
        ],
        city_code: [
          { required: true, message: "市不能为空", trigger: "change" },
        ],
        area_code: [
          { required: true, message: "省市区不能为空", trigger: "change" },
        ],
        published_at: [
          {
            required: true,
            message: "发布时间不能为空",
            trigger: "change",
          },
        ],
        enroll_end_at: [
          { required: true, message: "报名结束时间不能为空", trigger: "blur" },
        ],
        industries: [
          { required: true, message: "领域不能为空", trigger: "blur" },
        ],
        institute_id: [
          { required: true, message: "机构不能为空", trigger: "blur" },
        ],
        content: [{ required: true, message: "内容不能为空", trigger: "blur" }],
      },
    };
  },
  created() {
    if (this.$route.query.id) {
      this.form.id = this.$route.query.id;
    }
    console.log(this.form);
    if (this.form.id) {
      this.getDetail();
    }
  },
  methods: {
    getServiceTypeList() {
      request({
        url: "/api/backend/service/serviceTypeList",
        method: "get",
        params: {},
      }).then((res) => {
        this.serviceType = res.data;
      });
    },
    getCover() {
      if (this.form.id == 0) {
        this.regions.forEach((v) => {
          this.form.exhibition_area.push({
            exhibition_area_id: v.id,
            picture: "",
          });
        });
      } else {
        this.regions.forEach((v) => {
          let bool = false;
          this.form.exhibition_area.forEach((w) => {
            if (v.id == w.exhibition_area_id) {
              bool = true;
            }
          });
          if (!bool)
            this.form.exhibition_area.push({
              exhibition_area_id: v.id,
              picture: "",
            });
        });
      }
      console.log(this.form.exhibition_area);
    },
    getDetail() {
      this.listLoading = true;
      request({
        url: "/api/backend/systemNotify/details",
        method: "get",
        params: { id: this.form.id },
      }).then((res) => {
        this.form = res.data;
        this.listLoading = false;
      });
    },
    handleRemove(index) {
      if (this.form.exhibition_area[index].picture)
        this.form.exhibition_area[index].picture = "";
    },
    // 所在地选择
    getProvince() {
      return request({
        url: "/api/common/china/provinces",
        method: "get",
      }).then((res) => {
        this.provinces = res.data;
      });
    },
    getReCities() {
      if (this.form.province_code === "") {
        return;
      }

      return request({
        url: "/api/common/china/cities",
        method: "get",
        params: {
          province_code: this.form.province_code,
        },
      }).then((res) => {
        console.log(this.form.city_code);
        this.form.city_code = "";
        this.cities = res.data;
      });
    },
    closeReCities() {
      this.cities = [];
      this.form.city_code = "";
      this.areas = [];
      this.form.area_code = "";
    },
    getReAreas() {
      if (this.form.city_code === "") {
        return;
      }

      return request({
        url: "/api/common/china/areas",
        method: "get",
        params: {
          city_code: this.form.city_code,
        },
      }).then((res) => {
        this.areas = res.data;
      });
    },
    closeReAreas() {
      this.areas = [];
      this.form.area_code = "";
    },
    getInstitutes() {
      request({
        url: "/api/backend/roadshowActivity/instituteList",
        method: "get",
        params: {
          limit: 9999999999999,
        },
      }).then((response) => {
        this.institutes = response.data.data;
      });
    },
    getIndustrie(parent_id) {
      return request({
        url: "/api/common/industry/list",
        method: "get",
        params: {
          parent_id: parent_id,
        },
      }).then((res) => {
        this.industrie_detaileds = [];
        if (parent_id) {
          // this.industrie_detaileds = res.data;
          console.log(res.data);
          res.data.map((v) => {
            if (!this.form.industries.length)
              this.industrie_detaileds = res.data;
            else if (
              this.form.industries.findIndex((x) => x.id === v.id) === -1
            )
              this.industrie_detaileds.push(v);
          });
          console.log(this.industrie_detaileds);
        } else {
          this.industries = res.data;
        }
      });
    },
    closeIndustrie() {
      this.industrie_detaileds = [];
      this.form.industrie_detailed_id = "";
    },
    handler() {
      let bool = false;
      // if (this.form.enroll_end_at < this.form.enroll_start_at) {
      //   this.$message({
      //     type: "error",
      //     message: "报名开始时间要大于结束时间!",
      //   });
      //   return;
      // }
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          request({
            url: `/api/backend/systemNotify/store`,
            method: "post",
            data: this.form,
          })
            .then((response) => {
              this.btnLoading = false;
              this.showDialog = false;
              this.$notify({
                title: "成功",
                message: "保存成功",
                type: "success",
                duration: 2000,
              });
              this.$router.go(-1);
            })
            .catch((err) => {
              this.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
    handleClose(tag) {
      this.form.industries.splice(this.dynamicTags.indexOf(tag), 1);
    },

    showInput() {
      this.inputVisible = true;
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.form.industries.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
      this.industrie_id = "";
    },
  },
};
</script>

<style>
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
